import Prism from 'prismjs';
export default {
    install(app) {
        app.directive('prism', {
            beforeMount(el) {
                Prism.highlightAllUnder(el);
            },
            updated(el) {
                Prism.highlightAllUnder(el);
            }
        });
    }
};
